export function formatOrderTimestamp(iso: string): string {
  try {
    return new Date(iso).toLocaleString('en-GB', {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  } catch {
    return iso;
  }
}

export function getDeliveryLabelKey(method: string): string {
  const normalized = method.trim().toLowerCase();
  if (
    normalized === 'inpost' ||
    normalized === 'dpd' ||
    normalized === 'poczta' ||
    normalized === 'kurier'
  ) {
    return `checkout.delivery.${normalized}.name`;
  }
  return '';
}
